import Swiper from "swiper/swiper-bundle.esm";

export function getPromoSwiper() {
  // console.log("getPromoSwiper");
  const swiper = new Swiper("#promoSwiper", {
    loop: true,
    // cssMode: true,
    effect: 'fade',
    autoplay: {
      delay: 6000,
    },
    keyboard: true,

    // navigation: {
    //   nextEl: ".swiper-button-next",
    //   prevEl: ".swiper-button-prev",
    // },
    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },
    preloadImages: false,
    // Enable lazy loading
    lazy: {
      loadPrevNext: true,
    },
    on: {
      afterInit: function (swiper) {
        // console.log("getPromoSwiper - afterInit");
        var TYPE_CONTROL =
          swiper.slides[swiper.activeIndex].classList.contains("has-video");
        if (TYPE_CONTROL) {
          /* AUTO_PLAY OFF */
          swiper.autoplay.stop();
        } else {
          /* AUTO_PLAY ON */
          swiper.autoplay.start();
        }
      },
      slideChange: function (swiper) {
        var TYPE_CONTROL =
          swiper.slides[swiper.activeIndex].classList.contains("has-video");
        var autoplayDelay = swiper.params.autoplay.delay / 1000;
        var VIDEO = swiper.slides[swiper.activeIndex].firstElementChild;

        /* get Current Time */
        function getCurrentTime() {
          // document.getElementById("demo").innerHTML =
          //   VIDEO.currentTime.toFixed();
          var endTime = VIDEO.duration.toFixed();
          var currentTime = VIDEO.currentTime.toFixed();
          // var percentage = (currentTime / endTime) * 100;

          if (currentTime == endTime - autoplayDelay) {
            swiper.autoplay.start();
          }
        }
        /* end get Current Time */
        if (TYPE_CONTROL) {
          /* AUTO_PLAY OFF */
          swiper.autoplay.stop();
          // console.log(TYPE_CONTROL)
          // swiper.slides[swiper.activeIndex].firstElementChild.muted = true;

          swiper.slides[
            swiper.activeIndex
          ].firstElementChild.nextElementSibling.nextElementSibling.style.display =
            "none";

          swiper.slides[
            swiper.activeIndex
          ].firstElementChild.nextElementSibling.classList.add("play-icon");
          swiper.slides[
            swiper.activeIndex
          ].firstElementChild.nextElementSibling.classList.remove("pause-icon");

          /* VIDEO PLAY ON */
          // swiper.slides[swiper.activeIndex].firstElementChild.play();
          swiper.slides[
            swiper.activeIndex
          ].firstElementChild.nextElementSibling.addEventListener(
            "click",
            PlayVideo,
            false
          );
          function PlayVideo(e) {
            e.preventDefault();
            e.stopPropagation();

            // console.log("...this...", this);
            if (swiper.slides[swiper.activeIndex].firstElementChild.paused) {
              // console.log("if", this.paused);
              this.classList.add("play-icon");
              this.classList.remove("pause-icon");
              swiper.slides[
                swiper.activeIndex
              ].firstElementChild.nextElementSibling.nextElementSibling.style.display =
                "none";
            } else {
              // console.log("else", this.paused);
              this.classList.add("pause-icon");
              this.classList.remove("play-icon");
              swiper.slides[
                swiper.activeIndex
              ].firstElementChild.nextElementSibling.nextElementSibling.style.display =
                "flex";
            }
          }
          /* VIDEO MUTED ON OFF */
          let mutedBTN =
            swiper.slides[swiper.activeIndex].firstElementChild
              .nextElementSibling.nextElementSibling;

          mutedBTN.addEventListener("click", mutedOnOff, false);
          function mutedOnOff(e) {
            e.preventDefault();
            e.stopPropagation();

            mutedBTN.classList.remove("mute-btn--toggled");

            if (
              (this, swiper.slides[swiper.activeIndex].firstElementChild.muted)
            ) {
              // mutedBTN.innerHTML = "ON";
              mutedBTN.classList.add("mute-btn--toggled");
            } else {
              // mutedBTN.innerHTML = "OFF";
              mutedBTN.classList.remove("mute-btn--toggled");
            }
          }
          if (swiper.slides[swiper.activeIndex].firstElementChild.muted) {
            // mutedBTN.innerHTML = "ON";
            mutedBTN.classList.add("mute-btn--toggled");
          } else {
            // mutedBTN.innerHTML = "OFF";
            mutedBTN.classList.remove("mute-btn--toggled");
          }

          VIDEO.ontimeupdate = function () {
            getCurrentTime();
          };
          for (var i = 0; i < swiper.slides.length; i++) {
            var video = swiper.slides[i].querySelector("video");
            if (swiper.slides[i].classList.contains("has-video")) {
              video.pause();
            }
          }
        } else {
          /* AUTO_PLAY ON */
          swiper.autoplay.start();
          // console.log(TYPE_CONTROL)
          for (var i = 0; i < swiper.slides.length; i++) {
            var video = swiper.slides[i].querySelector("video");
            if (swiper.slides[i].classList.contains("has-video")) {
              video.pause();
            }
          }
        }
      },
    },
  });
}
/* global page */
function globalPageSwiper() {
  let globalPageSwiper = document.getElementsByClassName("globalPageSwiper");
  if (globalPageSwiper) {
    var swiper = new Swiper(".globalPageSwiper", {
      loop: true,
      // effect: 'fade',
      autoplay: {
        delay: 6000,
      },
      autoHeight: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      },
      lazy: {
        loadPrevNext: true,
      },
      preloadImages: false,

    });
  }
}
export { globalPageSwiper };


